import React, { useEffect, useRef,useState } from 'react';
import {
  VIEW_PROPOSAL_TW,
  SEARCH_CUSTOMER_BY_NUMBER,
  APPLICABLE_COVERS,
  PREVIOUS_POLICY_CLAIMS_DROPDOWN_DETAILS,
  FINANCER_DROPDOWN_DETAILS,
  GET_INTERMEDIARY_LIST,
} from './queries';
import { useQuery } from '@apollo/client';
// import { updateViewRenewMotorPolicyVar } from './_graphql/state';
import { updateViewRenewMotorPolicyVar } from 'quanta-flows/modules/policy/renewal/motor/state';
// import useFetchQuery from '../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import Loading from '../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
import RenewViewPolicySummaryPanel from './renew-view-policy-summary-panel';
import RenewViewPolicyWizardPanel from './renew-view-policy-wizard-panel';
// import { ClientService, Layout } from '../../../../lib/layout';
import { ClientService, Layout } from 'quanta-flows/modules/layout';
import {
  Card,
  useResponsiveParams,
  Text,
  Grid,
  GridItem,
} from 'quanta-ui';
import moment from 'moment';
export default function ViewRenewPolicyMotorPCV({
  customerID,
  product_name,
  proposal_number,
  product_code,
  renewal_mode,
  lobProductList,
  lobName,
  rcStatus,
  modify
}) {
  let nav = ['Policy', 'View Renew Policy'];
  const fetchQuery = useFetchQuery();
  const renewFormRef = useRef();
  const premiumFormRef = useRef();
  const alerts = useRef([]);
  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const screenType = useResponsiveParams({
    for_desktop: 'desktop',
    for_mobile: 'mobile',
    for_iPad: 'iPad',
  });

  const { loading, error, data } = useQuery(VIEW_PROPOSAL_TW, {
    variables: {
      input: {
        productCode: product_code,
        proposalNumber: proposal_number,
        customerID,
      },
    },
  });
const {
    loading: loadingCustomerDetails,
    error: errorCustomerDetails,
    data: dataCustomerDetails,
  } = useQuery(SEARCH_CUSTOMER_BY_NUMBER, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
      customer_type: 'Individual',
      customer_number: customerID,
      },
    },
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(GET_INTERMEDIARY_LIST);

  useEffect(() => {
    let isMounted = true;
    let startDate ;
    let end_date ;
    const fetchViewProposalData = async () => {
      if (
        data &&
        dataCustomerDetails &&
        dataMyIntermediaries &&
        isMounted
      ) {
        try {
          if (
            customerID?.toString()?.trim()?.toLowerCase() ===
            data?.viewProposalTW?.customerID
              ?.toString()
              ?.trim()
              ?.toLowerCase()
          ) {
            const customer = dataCustomerDetails?.customer;
            const getApplicableCovers = fetchQuery({
              query: APPLICABLE_COVERS,
              variables: {
                input: {
                  productCode: product_code,
                  productType: data?.viewProposalTW?.productType,
                  intermediaryCode: data?.viewProposalTW
                    ?.intermediaryDetails?.code
                    ? `${data?.viewProposalTW?.intermediaryDetails?.code}`
                    : '',
                  fuelType:
                    data?.viewProposalTW?.vehicleDetails?.fuelType,
                },
              },
            });
            const getPolicyTermTypePreviousPolicy = fetchQuery({
              query: PREVIOUS_POLICY_CLAIMS_DROPDOWN_DETAILS,
              variables: {
                productCode: product_code,
              },
            });
            const getFinancerDropdownDetailsQuery = fetchQuery({
              query: FINANCER_DROPDOWN_DETAILS,
              variables: {
                productCode: product_code,
              },
            });

            let { data: getApplicableCoversData } =
              await getApplicableCovers;
            let { data: getPolicyTermTypePreviousPolicyData } =
              await getPolicyTermTypePreviousPolicy;
            let { data: getFinancerDropdownDetailsData } =
              await getFinancerDropdownDetailsQuery;

            const { applicableCovers } = getApplicableCoversData;
            const {
              PRD_PreviousPolicyTermList,
              PRD_TotalClaimCountList,
            } = getPolicyTermTypePreviousPolicyData;

            const { PRD_FinancerAgreementType, PRD_IsYourVehicle } =
              getFinancerDropdownDetailsData;

            let addOnCovers = {};

            data?.viewProposalTW?.riskCovers?.forEach((riskCover) => {
              riskCover?.covers?.forEach((cover) => {
                addOnCovers[`${cover?.name}`] = {
                  selected: cover?.selected ? true : false,
                  isRenewalSelected: cover?.isRenewalSelected ? cover?.isRenewalSelected : true,
                  riskName: riskCover?.riskType,
                  index: cover?.index ? `${cover?.index}` : '',
                  attributes: {},
                };
                cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  .forEach((attribute) => {
                    addOnCovers[`${cover?.name}`][`attributes`][
                      `${attribute?.name}`
                    ] =
                      data?.viewProposalTW?.riskCovers
                        ?.find(
                          (rc) =>
                            rc?.riskType
                              ?.toString()
                              ?.toLowerCase() ===
                            riskCover?.riskType
                              ?.toString()
                              ?.toLowerCase(),
                        )
                        ?.covers?.find(
                          (c) =>
                            c?.name?.toString()?.toLowerCase() ===
                            cover?.name?.toString()?.toLowerCase(),
                        )
                        ?.attributes?.find(
                          (a) =>
                            a?.name?.toString()?.toLowerCase() ===
                            attribute?.name
                              ?.toString()
                              ?.toLowerCase(),
                        )?.dataValues?.length > 0
                        ? data?.viewProposalTW?.riskCovers
                            ?.find(
                              (rc) =>
                                rc?.riskType
                                  ?.toString()
                                  ?.toLowerCase() ===
                                riskCover?.riskType
                                  ?.toString()
                                  ?.toLowerCase(),
                            )
                            ?.covers?.find(
                              (c) =>
                                c?.name?.toString()?.toLowerCase() ===
                                cover?.name
                                  ?.toString()
                                  ?.toLowerCase(),
                            )
                            ?.attributes?.find(
                              (a) =>
                                a?.name?.toString()?.toLowerCase() ===
                                attribute?.name
                                  ?.toString()
                                  ?.toLowerCase(),
                            )
                            ?.dataValues?.find(
                              (dataValue) =>
                                dataValue?.code
                                  ?.toString()
                                  ?.toLowerCase() ===
                                attribute?.value
                                  ?.toString()
                                  ?.toLowerCase(),
                            )
                          ? attribute?.value
                          : attribute?.defaultValue
                        : attribute?.value
                        ? attribute?.value
                        : attribute?.defaultValue
                        ? attribute?.defaultValue
                        : '';
                  });
              });
            });
    /*SA Divya - added for break-in case --for  Expired Cases */
             if( rcStatus === 'false'){ // && data?.viewProposalTW?.policy 
              let Renewal_startDate = moment( data?.viewProposalTW?.policy?.startDate,"DD/MM/YYYY");//?.format('DD/MM/YYYY');
            if (Renewal_startDate.isBefore(moment(),"dates")){
              startDate = moment()?.format('DD/MM/YYYY');
            }
              
               if(startDate) {
                 end_date=moment(startDate,"DD/MM/YYYY")?.add(1,'year').subtract(1, 'days')?.format('DD/MM/YYYY');
               
               }
              
            }
             /*EA Divya */
            updateViewRenewMotorPolicyVar({
              otherCoverDetails: {
                isGeoAreaExtension: data?.viewProposalTW
                  ?.otherCoverDetails?.isGeoAreaExtension
                  ? true
                  : false,
                isBangladeshCovered: data?.viewProposalTW
                  ?.otherCoverDetails?.isBangladeshCovered
                  ? true
                  : false,
                isBhutanCovered: data?.viewProposalTW
                  ?.otherCoverDetails?.isBhutanCovered
                  ? true
                  : false,
                isMaldivesCovered: data?.viewProposalTW
                  ?.otherCoverDetails?.isMaldivesCovered
                  ? true
                  : false,
                isNepalCovered: data?.viewProposalTW
                  ?.otherCoverDetails?.isNepalCovered
                  ? true
                  : false,
                isPakistanCovered: data?.viewProposalTW
                  ?.otherCoverDetails?.isPakistanCovered
                  ? true
                  : false,
                isSriLankaCovered: data?.viewProposalTW
                  ?.otherCoverDetails?.isSriLankaCovered
                  ? true
                  : false,
                isVehicleForHandicapped: data?.viewProposalTW
                  ?.otherCoverDetails?.isVehicleForHandicapped
                  ? true
                  : false,
                isGlassFuelTank: data?.viewProposalTW
                  ?.otherCoverDetails?.isGlassFuelTank
                  ? true
                  : false,
              },
              IMT23:data?.viewProposalTW?.IMT23,
              IMT34:data?.viewProposalTW?.IMT34,
              intermediaryDetails: {
                code: data?.viewProposalTW?.intermediaryDetails?.code
                  ? `${data?.viewProposalTW?.intermediaryDetails?.code}`
                  : '',
                location: data?.viewProposalTW?.intermediaryDetails
                  ?.location
                  ? `${data?.viewProposalTW?.intermediaryDetails?.location}`
                  : '',
                fieldUserCode: data?.viewProposalTW
                  ?.intermediaryDetails?.fieldUserCode
                  ? `${data?.viewProposalTW?.intermediaryDetails?.fieldUserCode}`
                  : '',
                fieldUserName: data?.viewProposalTW
                  ?.intermediaryDetails?.fieldUserName
                  ? `${data?.viewProposalTW?.intermediaryDetails?.fieldUserName}`
                  : '',
              },
              enablecalcrenew:true,
              businessType: data?.viewProposalTW?.businessType
                ? `${data?.viewProposalTW?.businessType}`
                : '',
              businessTypeValue: data?.viewProposalTW?.businessType,
              customerFetchRequiredOnLoad: false,
              productType: data?.viewProposalTW?.productType
                ? `${data?.viewProposalTW?.productType}`
                : '',
              productTypeValue:
                lobProductList && lobProductList?.length > 0
                  ? lobProductList
                      ?.find(
                        (lob) =>
                          lob?.lob_name?.toLowerCase() ===
                          lobName?.toLowerCase(),
                      )
                      ?.products?.find(
                        (product) =>
                          product?.product_types?.find(
                            (pType) =>
                              pType?.code?.toLowerCase() ===
                              data?.viewProposalTW?.productType?.toLowerCase(),
                          ) !== undefined,
                      )
                      ?.product_types?.find(
                        (pType) =>
                          pType?.code?.toLowerCase() ===
                          data?.viewProposalTW?.productType?.toLowerCase(),
                      )?.value
                  : '',
              isQuoteSaved: true,
              quoteData: {
                get_covers: true,
                quotationNo: data?.viewProposalTW?.quoteNumber
                  ? `${data?.viewProposalTW?.quoteNumber}`
                  : '',
                quotationStatus: '',
                quoteCreationDate: '',
                productType: data?.viewProposalTW?.productType
                  ? `${data?.viewProposalTW?.productType}`
                  : '',
                proposalNumber: data?.viewProposalTW?.proposalNumber
                  ? `${data?.viewProposalTW?.proposalNumber}`
                  : '',
                productTypeValue:
                  lobProductList && lobProductList?.length > 0
                    ? lobProductList
                        ?.find(
                          (lob) =>
                            lob?.lob_name?.toLowerCase() ===
                            lobName?.toLowerCase(),
                        )
                        ?.products?.find(
                          (product) =>
                            product?.product_types?.find(
                              (pType) =>
                                pType?.code?.toLowerCase() ===
                                data?.viewProposalTW?.productType?.toLowerCase(),
                            ) !== undefined,
                        )
                        ?.product_types?.find(
                          (pType) =>
                            pType?.code?.toLowerCase() ===
                            data?.viewProposalTW?.productType?.toLowerCase(),
                        )?.value
                    : '',
                businessType: data?.viewProposalTW?.businessType
                  ? `${data?.viewProposalTW?.businessType}`
                  : '',
                businessTypeValue: data?.viewProposalTW?.businessType,
                regNo: data?.viewProposalTW?.vehicleDetails
                  ?.registrationNumber
                  ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber}`
                  : '',
                isRegNoVerified: true,
                isPrevClaimsAvailable: null,
                isPrevInsuranceAvailable: null,
                isPrevInsuranceLoading: false,
                mode: '',
                vehicleRegNo: {
                  part1:
                    data?.viewProposalTW?.vehicleDetails
                      ?.registrationNumber &&
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                      'new'
                      ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                          0,
                          2,
                        )}`
                      : '',
                  part2:
                    data?.viewProposalTW?.vehicleDetails
                      ?.registrationNumber &&
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                      'new'
                      ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                          2,
                          4,
                        )}`
                      : '',
                      part3:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !=='new'
                      ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 9
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(4,5)
                        : data?.viewProposalTW?.vehicleDetails?.registrationNumber.length === 10
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(4, 6) 
                        : data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 11
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(4, 7) 
                        : ''
                      :'',

                    part4:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                          data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !=='new'
                          ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 9
                            ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(5,9)
                              : data?.viewProposalTW?.vehicleDetails?.registrationNumber.length === 10
                              ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(6, 10) 
                              : data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 11
                              ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(7, 11) 
                            : ''
                          :'',
                },
                changedIDV: data?.viewProposalTW?.firstYearIDV
                  ? `${data?.viewProposalTW?.firstYearIDV}`
                  : '',
                adjustmentIRF: data?.viewProposalTW?.irf1
                  ? `${data?.viewProposalTW?.irf1}`
                  : '',
                anyPreviousPolicyforVehicleTaken: data?.viewProposalTW
                  ?.isPreviousPolicy
                  ? 'Yes'
                  : 'No',
                isVehicleDetailsAvailable: true,
                policyCoverType: data?.viewProposalTW
                  ?.prevInsuranceDetails?.coverType
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.coverType}`
                  : '',
                  totalIDV:data?.viewProposalTW?.totalIDV?
                  data?.viewProposalTW?.totalIDV
                 :'', 
                bodyIDV:data?.viewProposalTW
                 ?.bodyIDV? data?.viewProposalTW
                 ?.bodyIDV
                 :'', 
                policyTenure: data?.viewProposalTW
                  ?.prevInsuranceDetails?.policyTenure
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyTenure}`
                  : '',
                policyTenureValue:
                  PRD_PreviousPolicyTermList &&
                  PRD_PreviousPolicyTermList?.length > 0 &&
                  PRD_PreviousPolicyTermList?.find(
                    (policyTerm) =>
                      policyTerm?.code?.toLowerCase() ===
                      data?.viewProposalTW?.prevInsuranceDetails?.policyTenure?.toLowerCase(),
                  )?.value
                    ? PRD_PreviousPolicyTermList?.find(
                        (policyTerm) =>
                          policyTerm?.code?.toLowerCase() ===
                          data?.viewProposalTW?.prevInsuranceDetails?.policyTenure?.toLowerCase(),
                      )?.value
                    : '',
                policyStartDate: data?.viewProposalTW
                  ?.prevInsuranceDetails?.startDate
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.startDate}`
                  : '',
                policyExpiryDate: data?.viewProposalTW
                  ?.prevInsuranceDetails?.expiryDate
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.expiryDate}`
                  : '',
                totalClaimCount: data?.viewProposalTW?.previousClaims
                  ?.totalClaimCount
                  ? `${data?.viewProposalTW?.previousClaims?.totalClaimCount}`
                  : '',
                prevInsuranceDetailsGCV: data?.viewProposalTW
                  ?.prevInsuranceDetailsGCV
                  ? data?.viewProposalTW?.prevInsuranceDetailsGCV
                  : [],
                previousClaimsArray:data?.viewProposalTW?.previousClaimsArray
                ?data?.viewProposalTW?.previousClaimsArray
                :[],
                totalClaimCountValue:
                  PRD_TotalClaimCountList &&
                  PRD_TotalClaimCountList?.length > 0 &&
                  PRD_TotalClaimCountList?.find(
                    (totalClaimCount) =>
                      totalClaimCount?.code?.toLowerCase() ===
                      data?.viewProposalTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                  )?.value
                    ? PRD_TotalClaimCountList?.find(
                        (totalClaimCount) =>
                          totalClaimCount?.code?.toLowerCase() ===
                          data?.viewProposalTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                      )?.value
                    : '',
                noOfClaimsOneYear: data?.viewProposalTW
                  ?.previousClaims?.claimsInYear1
                  ? `${data?.viewProposalTW?.previousClaims?.claimsInYear1}`
                  : '',
                noOfClaimsTwoYears: data?.viewProposalTW
                  ?.previousClaims?.claimsInYear2
                  ? `${data?.viewProposalTW?.previousClaims?.claimsInYear2}`
                  : '',
                noOfClaimsThreeYears: data?.viewProposalTW
                  ?.previousClaims?.claimsInYear3
                  ? `${data?.viewProposalTW?.previousClaims?.claimsInYear3}`
                  : '',
                totalClaimAmount:
                  data?.viewProposalTW?.previousClaims
                    ?.totalClaimAmount !== null &&
                  data?.viewProposalTW?.previousClaims
                    ?.totalClaimAmount !== undefined
                    ? `${data?.viewProposalTW?.previousClaims?.totalClaimAmount}`
                    : '',
                previousYearNCBSlab: data?.viewProposalTW
                  ?.previousClaims
                  ? `${data?.viewProposalTW?.previousClaims?.prevNCBSlab}`
                  : '',
                vehicleIsOwnedBy: customer?.cust_type?.code
                  ? `${customer?.cust_type?.code}${
                      customer?.indv_detail?.gender?.code
                        ? `#${customer?.indv_detail?.gender?.code}`
                        : ''
                    }`
                  : '',
                vehicleOwnerTypeAndGender: {
                  gender: customer?.indv_detail?.gender?.code
                    ? `${customer?.indv_detail?.gender?.code}`
                    : '',
                  organisationType: customer?.cust_type?.code
                    ? `${customer?.cust_type?.code}`
                    : '',
                },
                pincode:
                  customer?.permanent_address?.pin_code ||
                  customer?.communication_address?.pin_code
                    ? `${
                        customer?.permanent_address?.pin_code ||
                        customer?.communication_address?.pin_code
                      }`
                    : '',
                state:
                  customer?.permanent_address?.state ||
                  customer?.communication_address?.state
                    ? `${
                        customer?.permanent_address?.state ||
                        customer?.communication_address?.state
                      }`
                    : '',
                city:
                  customer?.permanent_address?.city ||
                  customer?.communication_address?.city
                    ? `${
                        customer?.permanent_address?.city ||
                        customer?.communication_address?.city
                      }`
                    : '',
                district:
                  customer?.permanent_address?.district ||
                  customer?.communication_address?.district
                    ? `${
                        customer?.permanent_address?.district ||
                        customer?.communication_address?.district
                      }`
                    : '',
                getAdditionalCreditScore: data?.viewProposalTW
                  ?.creditScore?.discountOpted
                  ? 'Yes'
                  : 'No',
                idProofType:
                  data?.viewProposalTW?.creditScore?.discountOpted &&
                  data?.viewProposalTW?.creditScore?.idProofType
                    ? `${data?.viewProposalTW?.creditScore?.idProofType}`
                    : '',
                idProofNumber:
                  data?.viewProposalTW?.creditScore?.discountOpted &&
                  data?.viewProposalTW?.creditScore?.idProofNumber
                    ? `${data?.viewProposalTW?.creditScore?.idProofNumber}`
                    : '',
                voluntaryDeductibleAmount:
                  data?.viewProposalTW?.voluntaryDeductibleAmt !==
                    null &&
                  data?.viewProposalTW?.voluntaryDeductibleAmt !==
                    undefined &&
                  data?.viewProposalTW?.voluntaryDeductibleAmt !== ''
                    ? `${data?.viewProposalTW?.voluntaryDeductibleAmt}`
                    : '',
                make: {
                  code: data?.viewProposalTW?.vehicleDetails?.make
                    ?.code
                    ? `${data?.viewProposalTW?.vehicleDetails?.make?.code}`
                    : '',
                  value: data?.viewProposalTW?.vehicleDetails?.make
                    ?.value
                    ? `${data?.viewProposalTW?.vehicleDetails?.make?.value}`
                    : '',
                },
                model: {
                  code: data?.viewProposalTW?.vehicleDetails?.model
                    ?.code
                    ? `${data?.viewProposalTW?.vehicleDetails?.model?.code}`
                    : '',
                  value: data?.viewProposalTW?.vehicleDetails?.model
                    ?.value
                    ? `${data?.viewProposalTW?.vehicleDetails?.model?.value}`
                    : '',
                },
                variant: {
                  code: data?.viewProposalTW?.vehicleDetails?.variant
                    ?.code
                    ? `${data?.viewProposalTW?.vehicleDetails?.variant?.code}`
                    : '',
                  value: data?.viewProposalTW?.vehicleDetails?.variant
                    ?.value
                    ? `${data?.viewProposalTW?.vehicleDetails?.variant?.value}`
                    : '',
                },
                fuelType: data?.viewProposalTW?.vehicleDetails
                  ?.fuelType
                  ? `${data?.viewProposalTW?.vehicleDetails?.fuelType}`
                  : '',
                seatingCapacity: data?.viewProposalTW?.vehicleDetails
                  ?.seatingCapacity
                  ? `${data?.viewProposalTW?.vehicleDetails?.seatingCapacity}`
                  : '',
                cubeCapacity: data?.viewProposalTW?.vehicleDetails
                  ?.cubicCapacity
                  ? `${data?.viewProposalTW?.vehicleDetails?.cubicCapacity}`
                  : '',
                carryingCapacity:data?.viewProposalTW?.vehicleDetails
                  ?.carryingCapacity
                  ? `${data?.viewProposalTW?.vehicleDetails?.carryingCapacity}`
                  : '',
                GVW:data?.viewProposalTW?.vehicleDetails
                 ?.GVW
                 ? `${data?.viewProposalTW?.vehicleDetails?.GVW}`
                 : '',
                NCB:data?.viewProposalTW?.premium?.NCB,
                carriageType:data?.viewProposalTW?.vehicleDetails
                ?.carriageType
                ? `${data?.viewProposalTW?.vehicleDetails?.carriageType}`
                : '',
                permitType:data?.viewProposalTW?.vehicleDetails
                ?.permitType
                ? `${data?.viewProposalTW?.vehicleDetails?.permitType}`
                : '',
                vehicleUse:data?.viewProposalTW?.vehicleDetails
                ?.vehicleUse
                ? `${data?.viewProposalTW?.vehicleDetails?.vehicleUse}`
                : '',
                yearOfManufacture: data?.viewProposalTW
                  ?.vehicleDetails?.manufactureYear
                  ? `${data?.viewProposalTW?.vehicleDetails?.manufactureYear}`
                  : '',
                dateOfReg: data?.viewProposalTW?.vehicleDetails
                  ?.regPurchaseDate
                  ? `${data?.viewProposalTW?.vehicleDetails?.regPurchaseDate}`
                  : '',
                rtoLocationCode: data?.viewProposalTW?.rtoDetails
                  ?.rtoLocCode
                  ? `${data?.viewProposalTW?.rtoDetails?.rtoLocCode}`
                  : '',
                rtoLocationDesc: data?.viewProposalTW?.rtoDetails
                  ?.rtoLocDesc
                  ? `${data?.viewProposalTW?.rtoDetails?.rtoLocDesc}`
                  : '',
                rtoAuthorityCode: data?.viewProposalTW?.rtoDetails
                  ?.rtoAuthCode
                  ? `${data?.viewProposalTW?.rtoDetails?.rtoAuthCode}`
                  : '',
                engineNo: data?.viewProposalTW?.vehicleDetails
                  ?.engineNumber
                  ? `${data?.viewProposalTW?.vehicleDetails?.engineNumber}`
                  : '',
                chasisNo: data?.viewProposalTW?.vehicleDetails
                  ?.chasisNumber
                  ? `${data?.viewProposalTW?.vehicleDetails?.chasisNumber}`
                  : '',
                financerName: data?.viewProposalTW?.financerDetails
                  ?.financerName
                  ? `${data?.viewProposalTW?.financerDetails?.financerName}`
                  : '',
                prevInsurance: {
                  insurerName: data?.viewProposalTW
                    ?.prevInsuranceDetails?.insurerName
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.insurerName}`
                    : '',
                  policyNumber: data?.viewProposalTW
                    ?.prevInsuranceDetails?.policyNumber
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyNumber}`
                    : '',
                  expiryDate: data?.viewProposalTW
                    ?.prevInsuranceDetails?.expiryDate
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.expiryDate}`
                    : '',
                  startDate: data?.viewProposalTW
                    ?.prevInsuranceDetails?.startDate
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.startDate}`
                    : '',
                  coverType: data?.viewProposalTW
                    ?.prevInsuranceDetails?.coverType
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.coverType}`
                    : '',
                  policyTenure: data?.viewProposalTW
                    ?.prevInsuranceDetails?.policyTenure
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyTenure}`
                    : '',
                },
                tenure:'1',
                coverData: {
                  addOnCovers:
                    data?.viewProposalTW?.riskCovers &&
                    data?.viewProposalTW?.riskCovers?.length > 0
                      ? data?.viewProposalTW?.riskCovers
                      : [],
                  rawRiskData: applicableCovers?.riskCovers,
                },
                premiumData: {
                  idv1: data?.viewProposalTW?.premium?.idv1
                    ? `${data?.viewProposalTW?.premium?.idv1}`
                    : '',
                  idv2: data?.viewProposalTW?.premium?.idv2
                    ? `${data?.viewProposalTW?.premium?.idv2}`
                    : '',
                  idv3: data?.viewProposalTW?.premium?.idv3
                    ? `${data?.viewProposalTW?.premium?.idv3}`
                    : '',
                  tenure:'1',
                  netODPremium: data?.viewProposalTW?.premium
                    ?.netODPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.netODPremium,
                      )
                    : null,
                  netTPPremium: data?.viewProposalTW?.premium
                    ?.netTPPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.netTPPremium,
                      )
                    : null,
                  loadingDiscount: data?.viewProposalTW?.premium
                    ?.loadingDiscount
                    ? parseFloat(
                        data?.viewProposalTW?.premium
                          ?.loadingDiscount,
                      )
                    : null,
                  netPremium: data?.viewProposalTW?.premium
                    ?.netPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.netPremium,
                      )
                    : null,
                  gst: data?.viewProposalTW?.premium?.gst
                    ? parseFloat(data?.viewProposalTW?.premium?.gst)
                    : null,
                  stampDuty: data?.viewProposalTW?.premium?.stampDuty
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.stampDuty,
                      )
                    : null,
                  totalPremium: data?.viewProposalTW?.premium
                    ?.totalPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.stampDuty,
                      )
                    : null,
                    NCB: data?.viewProposalTW?.premium
                    ?.NCB
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.NCB,
                      )
                    : null,
                  loading:
                    data?.viewProposalTW?.premium?.loading &&
                    data?.viewProposalTW?.premium?.loading?.length > 0
                      ? data?.viewProposalTW?.premium?.loading
                      : [],
                  discount:
                    data?.viewProposalTW?.premium?.discount &&
                    data?.viewProposalTW?.premium?.discount?.length >
                      0
                      ? data?.viewProposalTW?.premium?.discount
                      : [],
                  vehicleAge: data?.viewProposalTW?.premium
                    ?.vehicleAge
                    ? `${data?.viewProposalTW?.premium?.vehicleAge}`
                    : '',
                  claimFreeYear: data?.viewProposalTW?.premium
                    ?.claimFreeYear
                    ? `${data?.viewProposalTW?.premium?.claimFreeYear}`
                    : '',
                  creditScore:
                    data?.viewProposalTW?.creditScore?.creditScore !==
                      null &&
                    data?.viewProposalTW?.creditScore?.creditScore !==
                      undefined &&
                    data?.viewProposalTW?.creditScore?.creditScore !==
                      ''
                      ? `${data?.viewProposalTW?.creditScore?.creditScore}`
                      : '',
                },
                customer: {
                  id: customer?.cust_number
                    ? `${customer?.cust_number}`
                    : '',
                  title: customer?.indv_detail?.title?.code
                    ? `${customer?.indv_detail?.title?.code}`
                    : '',
                  gender: customer?.indv_detail?.gender?.code
                    ? `${customer?.indv_detail?.gender?.code}`
                    : '',
                  firstName: customer?.indv_detail?.first_name
                    ? `${customer?.indv_detail?.first_name}`
                    : '',
                  middleName: customer?.indv_detail?.middle_name
                    ? `${customer?.indv_detail?.middle_name}`
                    : '',
                  lastName: customer?.indv_detail?.surname
                    ? `${customer?.indv_detail?.surname}`
                    : '',
                  fullName: customer?.indv_detail?.full_name
                    ? `${customer?.indv_detail?.full_name}`
                    : '',
                  proposerDOB: customer?.indv_detail?.date_of_birth
                    ? `${customer?.indv_detail?.date_of_birth}`
                    : '',
                  maritalStatus: customer?.indv_detail?.marital_status
                    ?.code
                    ? `${customer?.indv_detail?.marital_status?.code}`
                    : '',
                  occupation: customer?.indv_detail?.occupation?.code
                    ? `${customer?.indv_detail?.occupation?.code}`
                    : '',
                  nationality: customer?.indv_detail?.nationality
                    ?.code
                    ? `${customer?.indv_detail?.nationality?.code}`
                    : '',
                  idProofType: customer?.indv_detail?.id_proof_type
                    ?.code
                    ? `${customer?.indv_detail?.id_proof_type?.code}`
                    : '',
                  idProofNumber: customer?.indv_detail
                    ?.id_proof_number
                    ? `${customer?.indv_detail?.id_proof_number}`
                    : '',
                  panNumber: customer?.indv_detail?.pan_card_number
                    ? `${customer?.indv_detail?.pan_card_number}`
                    : customer?.org_detail?.pan_card_number
                    ? `${customer?.org_detail?.pan_card_number}`
                    : '',
                  orgName: customer?.org_detail?.org_name
                    ? `${customer?.org_detail?.org_name}`
                    : '',
                  orgType: customer?.org_detail?.org_type?.code
                    ? `${customer?.org_detail?.org_type?.code}`
                    : '',
                  contactName: customer?.org_detail?.contact_name
                    ? `${customer?.org_detail?.contact_name}`
                    : '',
                  regNumber: customer?.org_detail?.reg_number
                    ? `${customer?.org_detail?.reg_number}`
                    : '',
                  tanNumber: customer?.org_detail?.tan_number
                    ? `${customer?.org_detail?.tan_number}`
                    : '',
                  gstNumber:
                    customer?.org_detail?.gst_number ||
                    customer?.indv_detail?.gst_number
                      ? `${
                          customer?.org_detail?.gst_number ||
                          customer?.indv_detail?.gst_number
                        }`
                      : '',
                  permAddressLine1: customer?.permanent_address
                    ?.address_line1
                    ? `${customer?.permanent_address?.address_line1}`
                    : '',
                  permAddressLine2: customer?.permanent_address
                    ?.address_line2
                    ? `${customer?.permanent_address?.address_line2}`
                    : '',
                  permAddressLine3: customer?.permanent_address
                    ?.address_line3
                    ? `${customer?.permanent_address?.address_line3}`
                    : '',
                  permLandmark: customer?.permanent_address?.land_mark
                    ? `${customer?.permanent_address?.land_mark}`
                    : '',
                  permPincode: customer?.permanent_address?.pin_code
                    ? `${customer?.permanent_address?.pin_code}`
                    : '',
                  permCityTownVillage: customer?.permanent_address
                    ?.city
                    ? `${customer?.permanent_address?.city}`
                    : '',
                  permDistrict: customer?.permanent_address?.district
                    ? `${customer?.permanent_address?.district}`
                    : '',
                  permState: customer?.permanent_address?.state
                    ? `${customer?.permanent_address?.state}`
                    : '',
                  permCommAddressYN: customer?.comm_equal_perm
                    ? true
                    : false,
                  commAddressLine1: customer?.communication_address
                    ?.address_line1
                    ? `${customer?.communication_address?.address_line1}`
                    : '',
                  commAddressLine2: customer?.communication_address
                    ?.address_line2
                    ? `${customer?.communication_address?.address_line2}`
                    : '',
                  commAddressLine3: customer?.communication_address
                    ?.address_line3
                    ? `${customer?.communication_address?.address_line3}`
                    : '',
                  commLandmark: customer?.communication_address
                    .land_mark
                    ? `${customer?.communication_address?.land_mark}`
                    : '',
                  commPincode: customer?.communication_address
                    ?.pin_code
                    ? `${customer?.communication_address?.pin_code}`
                    : '',
                  commCityTownVillage: customer?.communication_address
                    ?.city
                    ? `${customer?.communication_address?.city}`
                    : '',
                  commDistrict: customer?.communication_address
                    ?.district
                    ? `${customer?.communication_address?.district}`
                    : '',
                  commState: customer?.communication_address?.state
                    ? `${customer?.communication_address?.state}`
                    : '',
                  phoneNo: customer?.contact?.telephone
                    ? `${customer?.contact?.telephone}`
                    : '',
                  mobileNo:
                    customer?.contact?.mobile ||
                    customer?.org_detail?.contact_mob
                      ? `${
                          customer?.contact?.mobile ||
                          customer?.org_detail?.contact_mob
                        }`
                      : '',
                  emailID:
                    customer?.contact?.email ||
                    customer?.org_detail?.contact_email
                      ? `${
                          customer?.contact?.email ||
                          customer?.org_detail?.contact_email
                        }`
                      : '',
                  faxNo: customer?.contact?.fax_number
                    ? `${customer?.contact?.fax_number}`
                    : '',
                  altPhoneNo: customer?.contact?.alt_telephone
                    ? `${customer?.contact?.alt_telephone}`
                    : '',
                  altMobileNo: customer?.contact?.alt_mobile
                    ? `${customer?.contact?.alt_mobile}`
                    : '',
                  employeeNumber: customer?.indv_detail
                    ?.employeeNumber
                    ? `${customer?.indv_detail?.employeeNumber}`
                    : '',
                },
                customerMeta: {
                  crn: customer?.cust_ref_number
                    ? `${customer?.cust_ref_number}`
                    : '',
                  isNewCustomer: false,
                  ifscCode: customer?.bank_detail?.ifsc_code
                    ? `${customer?.bank_detail?.ifsc_code}`
                    : '',
                  bankName: customer?.bank_detail?.name
                    ? `${customer?.bank_detail?.name}`
                    : '',
                  branchName: customer?.bank_detail?.branch_name
                    ? `${customer?.bank_detail?.branch_name}`
                    : '',
                  bankAcno: customer?.bank_detail?.acc_number
                    ? `${customer?.bank_detail?.acc_number}`
                    : '',
                  accountHolderName: customer?.bank_detail?.acc_holder
                    ? `${customer?.bank_detail?.acc_holder}`
                    : '',
                  micrCode: customer?.bank_detail?.micr_code
                    ? `${customer?.bank_detail?.micr_code}`
                    : '',
                },
                isPremiumCalculating: null,
              },
              coverData: {
                rawRiskData: applicableCovers?.riskCovers,
                addOnCovers,
                tenureList: applicableCovers?.tenure,
              },
              quoteNumber: data?.viewProposalTW?.quoteNumber
                ? `${data?.viewProposalTW?.quoteNumber}`
                : '',
              quoteStatus: '',
              quoteCreationDate: '',
              proposalNumber: data?.viewProposalTW?.proposalNumber
                ? `${data?.viewProposalTW?.proposalNumber}`
                : '',
              policyNumber: data?.viewProposalTW?.policyNumber
                ? `${data?.viewProposalTW?.policyNumber}`
                : '',
              proposalStatus: data?.viewProposalTW?.proposalStatus
                ? `${data?.viewProposalTW?.proposalStatus}`
                : '',
              proposalPaymentType: data?.viewProposalTW
                ?.proposalPaymentType
                ? `${data?.viewProposalTW?.proposalPaymentType}`
                : '',
              isProposalApplicableForPayment: data?.viewProposalTW
                ?.isApplicableForPayment
                ? true
                : false,
              UWCompleted:data?.viewProposalTW?.toString()?.toLowerCase()=='true'
                ?true:false,
              isPolicyIssued: false,
              isExistingEmployee: '',
              proposerDetailsMeta: {
                crn: customer?.cust_ref_number
                  ? `${customer?.cust_ref_number}`
                  : '',
                isNewCustomer: false,
                ifscCode: customer?.bank_detail?.ifsc_code
                  ? `${customer?.bank_detail?.ifsc_code}`
                  : '',
                bankName: customer?.bank_detail?.name
                  ? `${customer?.bank_detail?.name}`
                  : '',
                branchName: customer?.bank_detail?.branch_name
                  ? `${customer?.bank_detail?.branch_name}`
                  : '',
                bankAcno: customer?.bank_detail?.acc_number
                  ? `${customer?.bank_detail?.acc_number}`
                  : '',
                accountHolderName: customer?.bank_detail?.acc_holder
                  ? `${customer?.bank_detail?.acc_holder}`
                  : '',
                micrCode: customer?.bank_detail?.micr_code
                  ? `${customer?.bank_detail?.micr_code}`
                  : '',
              },
              proposerDetails: {
                id: customer?.cust_number
                  ? `${customer?.cust_number}`
                  : '',
                customerType: customer?.cust_type?.code
                  ? `${customer?.cust_type?.code}`
                  : '',
                isThinCustomer: false,
                title: customer?.indv_detail?.title?.code
                  ? `${customer?.indv_detail?.title?.code}`
                  : '',
                gender: customer?.indv_detail?.gender?.code
                  ? `${customer?.indv_detail?.gender?.code}`
                  : '',
                firstName: customer?.indv_detail?.first_name
                  ? `${customer?.indv_detail?.first_name}`
                  : '',
                middleName: customer?.indv_detail?.middle_name
                  ? `${customer?.indv_detail?.middle_name}`
                  : '',
                lastName: customer?.indv_detail?.surname
                  ? `${customer?.indv_detail?.surname}`
                  : '',
                fullName: customer?.indv_detail?.full_name
                  ? `${customer?.indv_detail?.full_name}`
                  : '',
                proposerDOB: customer?.indv_detail?.date_of_birth
                  ? `${customer?.indv_detail?.date_of_birth}`
                  : '',
                maritalStatus: customer?.indv_detail?.marital_status
                  ?.code
                  ? `${customer?.indv_detail?.marital_status?.code}`
                  : '',
                occupation: customer?.indv_detail?.occupation?.code
                  ? `${customer?.indv_detail?.occupation?.code}`
                  : '',
                nationality: customer?.indv_detail?.nationality?.code
                  ? `${customer?.indv_detail?.nationality?.code}`
                  : '',
                idProofType: customer?.indv_detail?.id_proof_type
                  ?.code
                  ? `${customer?.indv_detail?.id_proof_type?.code}`
                  : '',
                idProofNumber: customer?.indv_detail?.id_proof_number
                  ? `${customer?.indv_detail?.id_proof_number}`
                  : '',
                panNumber: customer?.indv_detail?.pan_card_number
                  ? `${customer?.indv_detail?.pan_card_number}`
                  : customer?.org_detail?.pan_card_number       /*CR 498  */
                  ? `${customer?.org_detail?.pan_card_number}`
                  : '',
                orgName: customer?.org_detail?.org_name
                  ? `${customer?.org_detail?.org_name}`
                  : '',
                orgType: customer?.org_detail?.org_type?.code
                  ? `${customer?.org_detail?.org_type?.code}`
                  : '',
                contactName: customer?.org_detail?.contact_name
                  ? `${customer?.org_detail?.contact_name}`
                  : '',
                regNumber: customer?.org_detail?.reg_number
                  ? `${customer?.org_detail?.reg_number}`
                  : '',
                tanNumber: customer?.org_detail?.tan_number
                  ? `${customer?.org_detail?.tan_number}`
                  : '',
                gstNumber:
                  customer?.org_detail?.gst_number ||
                  customer?.indv_detail?.gst_number
                    ? `${
                        customer?.org_detail?.gst_number ||
                        customer?.indv_detail?.gst_number
                      }`
                    : '',
                permAddressLine1: customer?.permanent_address
                  ?.address_line1
                  ? `${customer?.permanent_address?.address_line1}`
                  : '',
                permAddressLine2: customer?.permanent_address
                  ?.address_line2
                  ? `${customer?.permanent_address?.address_line2}`
                  : '',
                permAddressLine3: customer?.permanent_address
                  ?.address_line3
                  ? `${customer?.permanent_address?.address_line3}`
                  : '',
                permLandmark: customer?.permanent_address?.land_mark
                  ? `${customer?.permanent_address?.land_mark}`
                  : '',
                permPincode: customer?.permanent_address?.pin_code
                  ? `${customer?.permanent_address?.pin_code}`
                  : '',
                permCityTownVillage: customer?.permanent_address?.city
                  ? `${customer?.permanent_address?.city}`
                  : '',
                permDistrict: customer?.permanent_address?.district
                  ? `${customer?.permanent_address?.district}`
                  : '',
                permState: customer?.permanent_address?.state
                  ? `${customer?.permanent_address?.state}`
                  : '',
                permCommAddressYN: customer?.comm_equal_perm
                  ? true
                  : false,
                commAddressLine1: customer?.communication_address
                  ?.address_line1
                  ? `${customer?.communication_address?.address_line1}`
                  : '',
                commAddressLine2: customer?.communication_address
                  ?.address_line2
                  ? `${customer?.communication_address?.address_line2}`
                  : '',
                commAddressLine3: customer?.communication_address
                  ?.address_line3
                  ? `${customer?.communication_address?.address_line3}`
                  : '',
                commLandmark: customer?.communication_address
                  .land_mark
                  ? `${customer?.communication_address?.land_mark}`
                  : '',
                commPincode: customer?.communication_address?.pin_code
                  ? `${customer?.communication_address?.pin_code}`
                  : '',
                commCityTownVillage: customer?.communication_address
                  ?.city
                  ? `${customer?.communication_address?.city}`
                  : '',
                commDistrict: customer?.communication_address
                  ?.district
                  ? `${customer?.communication_address?.district}`
                  : '',
                commState: customer?.communication_address?.state
                  ? `${customer?.communication_address?.state}`
                  : '',
                phoneNo: customer?.contact?.telephone
                  ? `${customer?.contact?.telephone}`
                  : '',
                mobileNo:
                  customer?.contact?.mobile ||
                  customer?.org_detail?.contact_mob
                    ? `${
                        customer?.contact?.mobile ||
                        customer?.org_detail?.contact_mob
                      }`
                    : '',
                emailID:
                  customer?.contact?.email ||
                  customer?.org_detail?.contact_email
                    ? `${
                        customer?.contact?.email ||
                        customer?.org_detail?.contact_email
                      }`
                    : '',
                faxNo: customer?.contact?.fax_number
                  ? `${customer?.contact?.fax_number}`
                  : '',
                altPhoneNo: customer?.contact?.alt_telephone
                  ? `${customer?.contact?.alt_telephone}`
                  : '',
                altMobileNo: customer?.contact?.alt_mobile
                  ? `${customer?.contact?.alt_mobile}`
                  : '',
                employeeNumber: customer?.indv_detail?.employeeNumber
                  ? `${customer?.indv_detail?.employeeNumber}`
                  : '',
                  /*SADivya : CR P2_233 : KYC */
              motherMaidenName: customer?.indv_detail?.mother_maiden_name
               ? `${customer?.indv_detail?.mother_maiden_name}` 
               : '',
              ckycIdNumber: customer?.indv_detail?.ckyc_id_number 
              ? `${customer?.indv_detail?.ckyc_id_number}` :
              '' ,
              eiaRequired: customer?.indv_detail?.eia_required 
              ? `${customer?.indv_detail?.eia_required}`
              : '',
              eiaNumber: customer?.indv_detail?.eia_number 
              ? `${customer?.indv_detail?.eia_number}`
              :'',
              certificateOfInCorporation: 
              customer?.cust_type?.code?.toLowerCase() == 'organisation' ?
                customer?.indv_detail?.certificate_of_incorporation 
                ? `${customer?.indv_detail?.certificate_of_incorporation}` : '' 
              : '',
              udyogAadhaarNumber: customer?.org_detail?.udyog_aadhaar_number 
              ? `${customer?.org_detail?.udyog_aadhaar_number}` : '',
            /*EADivya : CR P2_233 :KYC */
              },
              vehicleTabDetails: {
                vehicleRegistrationDetails: {
                  registrationNumber: data?.viewProposalTW
                    ?.vehicleDetails?.registrationNumber
                    ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber}`
                    : '',
                  engineNumber: data?.viewProposalTW?.vehicleDetails
                    ?.engineNumber
                    ? `${data?.viewProposalTW?.vehicleDetails?.engineNumber}`
                    : '',
                  chasisNumber: data?.viewProposalTW?.vehicleDetails
                    ?.chasisNumber
                    ? `${data?.viewProposalTW?.vehicleDetails?.chasisNumber}`
                    : '',
                  registrationNumberParts: {
                    part1:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                        'new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                            0,
                            2,
                          )
                        : '',
                    part2:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                        'new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                            2,
                            4,
                          )
                        : '',
                        part3:
                        data?.viewProposalTW?.vehicleDetails
                          ?.registrationNumber &&
                        data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !=='new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 9
                          ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(4,5)
                          : data?.viewProposalTW?.vehicleDetails?.registrationNumber.length === 10
                          ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(4, 6) 
                          : data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 11
                          ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(4, 7) 
                          : ''
                        :'',
  
                      part4:
                        data?.viewProposalTW?.vehicleDetails
                          ?.registrationNumber &&
                            data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !=='new'
                            ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 9
                              ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(5,9)
                                : data?.viewProposalTW?.vehicleDetails?.registrationNumber.length === 10
                                ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(6, 10) 
                                : data?.viewProposalTW?.vehicleDetails?.registrationNumber?.length === 11
                                ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(7, 11) 
                              : ''
                            :'',
                  },
                  isNewVehicle:
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() ===
                    'new',
                },
                vehicleDetails: {
                  make: {
                    code: data?.viewProposalTW?.vehicleDetails?.make
                      ?.code
                      ? `${data?.viewProposalTW?.vehicleDetails?.make?.code}`
                      : '',
                    value: data?.viewProposalTW?.vehicleDetails?.make
                      ?.value
                      ? `${data?.viewProposalTW?.vehicleDetails?.make?.value}`
                      : '',
                  },
                  model: {
                    code: data?.viewProposalTW?.vehicleDetails?.model
                      ?.code
                      ? `${data?.viewProposalTW?.vehicleDetails?.model?.code}`
                      : '',
                    value: data?.viewProposalTW?.vehicleDetails?.model
                      ?.value
                      ? `${data?.viewProposalTW?.vehicleDetails?.model?.value}`
                      : '',
                  },
                  variant: {
                    code: data?.viewProposalTW?.vehicleDetails
                      ?.variant?.code
                      ? `${data?.viewProposalTW?.vehicleDetails?.variant?.code}`
                      : '',
                    value: data?.viewProposalTW?.vehicleDetails
                      ?.variant?.value
                      ? `${data?.viewProposalTW?.vehicleDetails?.variant?.value}`
                      : '',
                  },
                  fuelType: data?.viewProposalTW?.vehicleDetails
                    ?.fuelType
                    ? `${data?.viewProposalTW?.vehicleDetails?.fuelType}`
                    : '',
                  cubeCapacity: data?.viewProposalTW?.vehicleDetails
                    ?.cubicCapacity
                    ? `${data?.viewProposalTW?.vehicleDetails?.cubicCapacity}`
                    : '',
                  seatingCapacity: data?.viewProposalTW
                    ?.vehicleDetails?.seatingCapacity
                    ? `${data?.viewProposalTW?.vehicleDetails?.seatingCapacity}`
                    : '',
                  yearOfManufacture: data?.viewProposalTW
                    ?.vehicleDetails?.manufactureYear
                    ? `${data?.viewProposalTW?.vehicleDetails?.manufactureYear}`
                    : '',
                  rtoDetails: {
                    rtoAuthorityCode: data?.viewProposalTW?.rtoDetails
                      ?.rtoAuthCode
                      ? `${data?.viewProposalTW?.rtoDetails?.rtoAuthCode}`
                      : '',
                    rtoLocationCode: data?.viewProposalTW?.rtoDetails
                      ?.rtoLocCode
                      ? `${data?.viewProposalTW?.rtoDetails?.rtoLocCode}`
                      : '',
                    rtoLocationDesc: data?.viewProposalTW?.rtoDetails
                      ?.rtoLocDesc
                      ? `${data?.viewProposalTW?.rtoDetails?.rtoLocDesc}`
                      : '',
                  },
                  dateOfRegistration: data?.viewProposalTW
                    ?.vehicleDetails?.regPurchaseDate
                    ? `${data?.viewProposalTW?.vehicleDetails?.regPurchaseDate}`
                    : '',
                  preInspectionNumber: data?.viewProposalTW
                    ?.vehicleDetails?.preInspectionNumber
                    ? `${data?.viewProposalTW?.vehicleDetails?.preInspectionNumber}`
                    : '',
                  vehicleSegment: data?.viewProposalTW?.vehicleDetails
                    ?.vehicleSegment
                    ? `${data?.viewProposalTW?.vehicleDetails?.vehicleSegment}`
                    : '',
                },
                insuredDeclaredDetails: {
                  vehicleIDV: data?.viewProposalTW?.firstYearIDV
                    ? parseFloat(data?.viewProposalTW?.firstYearIDV)
                    : null,
                  irfAdjustmentPercent: data?.viewProposalTW?.irf1
                    ? `${data?.viewProposalTW?.irf1}`
                    : '',
                  idvPct: 15,
                  irfPctMin:15,
                  irfPct: data?.viewProposalTW?.irfPct
                    ? data?.viewProposalTW?.irfPct
                    : 200,
                  minChangedIDV: data?.viewProposalTW?.minChangedIDV
                    ? parseFloat(data?.viewProposalTW?.minChangedIDV)
                    : 0.9 *
                      parseFloat(data?.viewProposalTW?.firstYearIDV),
                  maxChangedIDV: data?.viewProposalTW?.maxChangedIDV
                    ? parseFloat(data?.viewProposalTW?.maxChangedIDV)
                    : 1.1 *
                      parseFloat(data?.viewProposalTW?.firstYearIDV),
                  sideCarValue: data?.viewProposalTW?.sideCarValue
                    ? parseFloat(data?.viewProposalTW?.sideCarValue)
                    : null,
                  sideCarPct: data?.viewProposalTW?.sideCarPct
                    ? parseFloat(data?.viewProposalTW?.sideCarPct)
                    : 10,
                  minSideCarValue: data?.viewProposalTW
                    ?.minSideCarValue
                    ? parseFloat(
                        data?.viewProposalTW?.minSideCarValue,
                      )
                    : 0.9 *
                      parseFloat(data?.viewProposalTW?.sideCarValue),
                  maxSideCarValue: data?.viewProposalTW
                    ?.maxSideCarValue
                    ? parseFloat(
                        data?.viewProposalTW?.maxSideCarValue,
                      )
                    : 1.1 *
                      parseFloat(data?.viewProposalTW?.sideCarValue),
                },
              },
              additionalTabDetails: {
                previousInsuranceAndClaims: {
                  previousPolicyDetails: {
                    previousInsurerName: data?.viewProposalTW
                      ?.prevInsuranceDetails?.insurerName
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.insurerName}`
                      : '',
                    expiringPolicyNumber: data?.viewProposalTW
                      ?.prevInsuranceDetails?.policyNumber
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyNumber}`
                      : '',
                    policyCoverType: data?.viewProposalTW
                      ?.prevInsuranceDetails?.coverType
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.coverType}`
                      : '',
                    policyStartDate: data?.viewProposalTW
                      ?.prevInsuranceDetails?.startDate
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.startDate}`
                      : '',
                    policyExpiryDate: data?.viewProposalTW
                      ?.prevInsuranceDetails?.expiryDate
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.expiryDate}`
                      : '',
                    policyTenure: data?.viewProposalTW
                      ?.prevInsuranceDetails?.policyTenure
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyTenure}`
                      : '',
                    policyTenureValue:
                      PRD_PreviousPolicyTermList &&
                      PRD_PreviousPolicyTermList?.length > 0 &&
                      PRD_PreviousPolicyTermList?.find(
                        (policyTerm) =>
                          policyTerm?.code?.toLowerCase() ===
                          data?.viewProposalTW?.prevInsuranceDetails?.policyTenure?.toLowerCase(),
                      )?.value
                        ? PRD_PreviousPolicyTermList?.find(
                            (policyTerm) =>
                              policyTerm?.code?.toLowerCase() ===
                              data?.viewProposalTW?.prevInsuranceDetails?.policyTenure?.toLowerCase(),
                          )?.value
                        : '',
                  },
                  previousClaims: {
                    totalClaimCount: data?.viewProposalTW
                      ?.previousClaims?.totalClaimCount
                      ? `${data?.viewProposalTW?.previousClaims?.totalClaimCount}`
                      : '',
                    totalClaimCountValue:
                      PRD_TotalClaimCountList &&
                      PRD_TotalClaimCountList?.length > 0 &&
                      PRD_TotalClaimCountList?.find(
                        (totalClaimCount) =>
                          totalClaimCount?.code?.toLowerCase() ===
                          data?.viewProposalTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                      )?.value
                        ? PRD_TotalClaimCountList?.find(
                            (totalClaimCount) =>
                              totalClaimCount?.code?.toLowerCase() ===
                              data?.viewProposalTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                          )?.value
                        : '',
                    totalClaimAmount:
                      data?.viewProposalTW?.previousClaims
                        ?.totalClaimAmount !== null &&
                      data?.viewProposalTW?.previousClaims
                        ?.totalClaimAmount !== undefined
                        ? `${data?.viewProposalTW?.previousClaims?.totalClaimAmount}`
                        : '',
                    previousYearNCBSlab: data?.viewProposalTW
                      ?.previousClaims?.prevNCBSlab
                      ? `${data?.viewProposalTW?.previousClaims?.prevNCBSlab}`
                      : '',
                    noOfClaimsYear1: data?.viewProposalTW
                      ?.previousClaims?.claimsInYear1
                      ? `${data?.viewProposalTW?.previousClaims?.claimsInYear1}`
                      : '',
                    noOfClaimsYear2: data?.viewProposalTW
                      ?.previousClaims?.claimsInYear2
                      ? `${data?.viewProposalTW?.previousClaims?.claimsInYear2}`
                      : '',
                    noOfClaimsYear3: data?.viewProposalTW
                      ?.previousClaims?.claimsInYear3
                      ? `${data?.viewProposalTW?.previousClaims?.claimsInYear3}`
                      : '',
                  },
                },
                nomineeDetails: {
                  nomineeName: data?.viewProposalTW
                  ?.nomineeDetails?.name
                  ? `${data?.viewProposalTW?.nomineeDetails?.name}`
                  : '',
                  nomineeDob: data?.viewProposalTW
                  ?.nomineeDetails?.dob
                  ? `${data?.viewProposalTW?.nomineeDetails?.dob}`
                  : '',
                  relationshipWithNominee: data?.viewProposalTW
                  ?.nomineeDetails?.relationship
                  ? `${data?.viewProposalTW?.nomineeDetails?.relationship}`
                  : '',
                  nameOfAppointee: data?.viewProposalTW
                  ?.nomineeDetails?.nameOfAppointee
                  ? `${data?.viewProposalTW?.nomineeDetails?.nameOfAppointee}`
                  : '',
                  relationshipWithAppointee: data?.viewProposalTW
                  ?.nomineeDetails?.relationshipWithAppointee
                  ? `${data?.viewProposalTW?.nomineeDetails?.relationshipWithAppointee}`
                  : '',
                },
                financeDetails: {
                  vehicleOwned:
                    data?.viewProposalTW?.financerDetails
                      ?.vehicleOwned &&
                    PRD_IsYourVehicle &&
                    PRD_IsYourVehicle?.length > 0
                      ? PRD_IsYourVehicle?.find(
                          (isYourVehicle) =>
                            isYourVehicle?.code
                              ?.toString()
                              ?.trim()
                              ?.toLowerCase() ===
                            data?.viewProposalTW?.financerDetails?.vehicleOwned
                              ?.toString()
                              ?.trim()
                              ?.toLowerCase(),
                        )
                        ? `${
                            PRD_IsYourVehicle?.find(
                              (isYourVehicle) =>
                                isYourVehicle?.code
                                  ?.toString()
                                  ?.trim()
                                  ?.toLowerCase() ===
                                data?.viewProposalTW?.financerDetails?.vehicleOwned
                                  ?.toString()
                                  ?.trim()
                                  ?.toLowerCase(),
                            )?.code
                          }`
                        : ''
                      : '',
                  financerDetails: {
                    financerName: data?.viewProposalTW
                      ?.financerDetails?.financerName
                      ? `${data?.viewProposalTW?.financerDetails?.financerName}`
                      : '',
                    financerAddress: data?.viewProposalTW
                      ?.financerDetails?.financerAddress
                      ? `${data?.viewProposalTW?.financerDetails?.financerAddress}`
                      : '',
                    financerAgreementType:
                      data?.viewProposalTW?.financerDetails
                        ?.financerAgreementType &&
                      PRD_FinancerAgreementType &&
                      PRD_FinancerAgreementType?.length > 0
                        ? PRD_FinancerAgreementType?.find(
                            (financerAgreementType) =>
                              financerAgreementType?.code
                                ?.toString()
                                ?.trim()
                                ?.toLowerCase() ===
                              data?.viewProposalTW?.financerDetails?.financerAgreementType
                                ?.toString()
                                ?.trim()
                                ?.toLowerCase(),
                          )
                          ? `${
                              PRD_FinancerAgreementType?.find(
                                (financerAgreementType) =>
                                  financerAgreementType?.code
                                    ?.toString()
                                    ?.trim()
                                    ?.toLowerCase() ===
                                  data?.viewProposalTW?.financerDetails?.financerAgreementType
                                    ?.toString()
                                    ?.trim()
                                    ?.toLowerCase(),
                              )?.code
                            }`
                          : ''
                        : '',
                    loanAccountNumber: data?.viewProposalTW
                      ?.financerDetails?.loanAccountNumber
                      ? `${data?.viewProposalTW?.financerDetails?.loanAccountNumber}`
                      : '',
                    fileNumber: data?.viewProposalTW?.financerDetails
                      ?.fileNumber
                      ? `${data?.viewProposalTW?.financerDetails?.fileNumber}`
                      : '',
                  },
                },
              },
              reviewAndConfirmTabDetails: {
                leadGenerator: data?.viewProposalTW?.leadGenerator
                  ? `${data?.viewProposalTW?.leadGenerator}`
                  : '',
                isProposalCreated: true,
                proposalPaymentType: data?.viewProposalTW
                  ?.proposalPaymentType
                  ? `${data?.viewProposalTW?.proposalPaymentType}`
                  : '',
              },
              policy: {
                startDate: startDate ? startDate :
                  data?.viewProposalTW?.policy?.startDate
                  ? `${data?.viewProposalTW?.policy?.startDate}`
                  : '',
                endDate: end_date ? end_date :
                data?.viewProposalTW?.policy?.endDate
                  ? `${data?.viewProposalTW?.policy?.endDate}`
                  : '',
                time: data?.viewProposalTW?.policy?.time
                  ? `${data?.viewProposalTW?.policy?.time}`
                  : '',
              },
              issuedPolicyData: {
                policyNo: '',
                receiptID: [],
                referenceNumber: '',
                digiLink: '',
                displayMessage: '',
                additionalMessage: '',
              },
              premiumData: {
                idv1: data?.viewProposalTW?.premium?.idv1
                  ? `${data?.viewProposalTW?.premium?.idv1}`
                  : '',
                idv2: data?.viewProposalTW?.premium?.idv2
                  ? `${data?.viewProposalTW?.premium?.idv2}`
                  : '',
                idv3: data?.viewProposalTW?.premium?.idv3
                  ? `${data?.viewProposalTW?.premium?.idv3}`
                  : '',
                tenure: data?.viewProposalTW?.premium?.tenure
                  ? `${data?.viewProposalTW?.premium?.tenure}`
                  : '',
                netODPremium: parseFloat(
                  data?.viewProposalTW?.premium?.netODPremium,
                ),
                netTPPremium: parseFloat(
                  data?.viewProposalTW?.premium?.netTPPremium,
                ),
                loadingDiscount: parseFloat(
                  data?.viewProposalTW?.premium?.loadingDiscount,
                ),
                netPremium: parseFloat(
                  data?.viewProposalTW?.premium?.netPremium,
                ),
                gst: parseFloat(data?.viewProposalTW?.premium?.gst),
                stampDuty: parseFloat(
                  data?.viewProposalTW?.premium?.stampDuty,
                ),
                totalPremium: parseFloat(
                  data?.viewProposalTW?.premium?.totalPremium,
                ),
                loading:
                  data?.viewProposalTW?.premium?.loading &&
                  data?.viewProposalTW?.premium?.loading?.length > 0
                    ? data?.viewProposalTW?.premium?.loading
                    : [],
                discount:
                  data?.viewProposalTW?.premium?.discount &&
                  data?.viewProposalTW?.premium?.discount?.length > 0
                    ? data?.viewProposalTW?.premium?.discount
                    : [],
                vehicleAge: data?.viewProposalTW?.premium?.vehicleAge
                  ? `${data?.viewProposalTW?.premium?.vehicleAge}`
                  : '',
                claimFreeYear: data?.viewProposalTW?.premium
                  ?.claimFreeYear
                  ? `${data?.viewProposalTW?.premium?.claimFreeYear}`
                  : '',
                creditScore:
                  data?.viewProposalTW?.creditScore?.creditScore !==
                    null &&
                  data?.viewProposalTW?.creditScore?.creditScore !==
                    undefined &&
                  data?.viewProposalTW?.creditScore?.creditScore !==
                    ''
                    ? `${data?.viewProposalTW?.creditScore?.creditScore}`
                    : '',
              },
              premiumDetails: {
                termsAndConditions: false,
                paymentMethod: '',
                payerType: '',
                onlinePayment: {
                  transactionId: '',
                  isTransactionIdVerified: null,
                },
                cdWallet: {
                  cdAccountNo: '',
                  cdAccountBalance: '',
                },
                cheque: [],
                demandDraft: [],
              },
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchViewProposalData();
    return () => {
      isMounted = false;
    };
  }, [data, dataCustomerDetails, dataMyIntermediaries]);

  return loading ||
    loadingCustomerDetails ||
    loadingMyIntermediaries ? (
    <Loading />
  ) : error || errorCustomerDetails || errorMyIntermediaries ? (
    <Error
      error={error || errorCustomerDetails || errorMyIntermediaries}
    />
  ) : (
    <Layout
      nav={nav}
      service_type={ClientService}
      title={
        customerID?.toString()?.toLowerCase() !==
        data?.viewProposalTW?.customerID?.toString()?.toLowerCase()
          ? undefined
          : `Your ${product_name} Renewal Proposal`
      }
    >
      {customerID?.toString()?.toLowerCase() ===
        data?.viewProposalTW?.customerID?.toString()?.toLowerCase() &&
      dataMyIntermediaries?.myIntermediaries?.find(
        (myIntermediary) =>
          myIntermediary?.intermediaryCode
            ?.toString()
            ?.toLowerCase() ===
          data?.viewProposalTW?.intermediaryDetails?.code
            ?.toString()
            ?.toLowerCase(),
      ) ? (
        <>
          {screenType?.toString()?.toLowerCase() === 'desktop' && (
            <Grid
              repeat={12}
              gap={0}
              className="space-x-4 w-full mr-4"
            >
              <GridItem colSpan={9}>
                <RenewViewPolicyWizardPanel
                  forwardedRenewFormRef={renewFormRef}
                  forwardedPremiumFormRef={premiumFormRef}
                  forwardedAlertsRef={alerts}
                  {...{
                    lobCode: lobProductList?.find(
                      (lob) =>
                        lob?.lob_name?.toString()?.toLowerCase() ===
                        lobName?.toString()?.toLowerCase(),
                    )?.lob_code,
                    lobName,
                    productCode: product_code,
                    productName: product_name,
                    productType: data?.viewProposalTW?.productType,
                    renewalMode: renewal_mode,
		                rcStatus: rcStatus,
                    UWCompleted: data?.viewProposalTW?.UWCompleted,
                    modify: modify
                  }}
                />
              </GridItem>
              <GridItem colSpan={3}>
                <RenewViewPolicySummaryPanel
                  forwardedRenewFormRef={renewFormRef}
                  forwardedPremiumFormRef={premiumFormRef}
                  forwardedAlertsRef={alerts}
                  {...{
                    lobCode: lobProductList?.find(
                      (lob) =>
                        lob?.lob_name?.toString()?.toLowerCase() ===
                        lobName?.toString()?.toLowerCase(),
                    )?.lob_code,
                    lobName,
                    productCode: product_code,
                    productName: product_name,
                    productType: data?.viewProposalTW?.productType,
                    renewalMode: renewal_mode,
                    modify:modify
                  }}
                />
              </GridItem>
            </Grid>
          )}
          {screenType?.toString()?.toLowerCase() !== 'desktop' && (
            <RenewViewPolicyWizardPanel
              forwardedRenewFormRef={renewFormRef}
              forwardedPremiumFormRef={premiumFormRef}
              forwardedAlertsRef={alerts}
              {...{
                lobCode: lobProductList?.find(
                  (lob) =>
                    lob?.lob_name?.toString()?.toLowerCase() ===
                    lobName?.toString()?.toLowerCase(),
                )?.lob_code,
                lobName,
                productCode: product_code,
                productName: product_name,
                productType: data?.viewProposalTW?.productType,
                renewalMode: renewal_mode,
                rcStatus: rcStatus,
                UWCompleted: data?.viewProposalTW?.UWCompleted,
                modify:modify
              }}
            />
          )}
          <div className="bg-neutral sticky bottom-0 p-3 -mx-4 mt-2 -mb-4 xl:hidden">
            <RenewViewPolicySummaryPanel
              forwardedRenewFormRef={renewFormRef}
              forwardedPremiumFormRef={premiumFormRef}
              forwardedAlertsRef={alerts}
              {...{
                lobCode: lobProductList?.find(
                  (lob) =>
                    lob?.lob_name?.toString()?.toLowerCase() ===
                    lobName?.toString()?.toLowerCase(),
                )?.lob_code,
                lobName,
                productCode: product_code,
                productName: product_name,
                productType: data?.viewProposalTW?.productType,
                renewalMode: renewal_mode,
                modify:modify
              }}
            />
          </div>
        </>
      ) : customerID?.toString()?.toLowerCase() !==
        data?.viewProposalTW?.customerID
          ?.toString()
          ?.toLowerCase() ? (
        <Card className="h-screen" severity={`error`}>
          <Text
            severity={'error'}
            className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
          >
            Incorrect Customer ID for the given Proposal Number.
          </Text>
        </Card>
      ) : (
        <Card className="h-screen" severity={`error`}>
          <Text
            severity={'error'}
            className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
          >
            Access denied.You are not allowed to view proposal
            belonging to another intermediary.
          </Text>
        </Card>
      )}
    </Layout>
  );
}
